// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"442":"e93c7c37","456":"fa714356"}[chunkId] + ".chunk.js";
};